import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import VendaForm from '../components/VendaForm';
import PedidosProdutosPrintModal from "../relatorios/PedidosProdutosPrintModal";
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import Colors from '../utils/Colors';

const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalVendas: 0,
    custoTotal: 0,
    custoMedioUnit: 0,
    vendaMediaUnit: 0,
    lucroMedioUnit: 0,
    lucroTotal: 0,
    qtdeVendas: 0,
    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'PV',
      buscaOrdem: { campo: 'ven_dt_venda', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0' },
      buscaProduto: { key: '0' },
      buscaGrupoProduto: { key: '0' },
      buscaMarcaProduto: { key: '0' },
      buscaServico: { key: '0' },
      buscaUsuario: { key: '0' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({
      listaRegistros: [], carregando: true, totalVendas: 0, custoTotal: 0,
      custoMedioUnit: 0, vendaMediaUnit: 0, lucroMedioUnit: 0, lucroTotal: 0, qtdeVendas: 0
    });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa,
      buscaProduto, buscaGrupoProduto, buscaMarcaProduto, buscaUsuario, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/vendas/listaProdutosHistorico', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          pessoa: buscaPessoa.key,
          produto: buscaProduto.pest_item,
          tamanho: buscaProduto.pest_tamanho,
          cor: buscaProduto.pest_cor,
          grupoProduto: buscaGrupoProduto.key,
          marcaProduto: buscaMarcaProduto.key,
          usuario: buscaUsuario.key,
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalVendas: response.data.vlrTotal,
          custoTotal: response.data.custoTotal,
          custoMedioUnit: response.data.custoTotal / response.data.qtde,
          vendaMediaUnit: response.data.vlrTotal / response.data.qtde,
          lucroMedioUnit: response.data.custoTotal ? ((((response.data.vlrTotal / response.data.custoTotal) - 1) * 100) / response.data.qtde) : 0,
          lucroTotal: response.data.custoTotal ? (((response.data.vlrTotal / response.data.custoTotal) - 1) * 100) : 0,
          qtdeVendas: response.data.qtde,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };




  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onVisualizarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/vendas/show/${registro.ven_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.ven_pessoa = {
          key: String(data.dados.ven_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.ven_cond_pagto = {
          key: data.dados.ven_cond_pagto ? String(data.dados.ven_cond_pagto) : '',
          label: data.dados.cp_descricao,
          qtdeParc: data.dados.cp_qtde_parc,
          parcAVista: data.dados.cp_parc_avista,
        }
        data.dados.ven_tipo_doc = {
          key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tparc_tipo_doc) ? String(data.listaParcelas[0].tparc_tipo_doc) : '',
          label: (data.listaParcelas.length > 0 && data.listaParcelas[0].td_descricao) ? String(data.listaParcelas[0].td_descricao) : '',
        }

        data.dados.ven_dt_venda = moment(data.dados.ven_dt_venda, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.visualizando = true;

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros()
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };




  renderData = (data, registro) => {
    const dataMoment = registro.ven_dt_venda ? moment(registro.ven_dt_venda) : moment(registro.os_data_emissao);
    if (dataMoment) {
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderNumero = (data, registro) => {
    return (
      <span>
        {registro.ven_numero ? registro.ven_numero : registro.os_numero}
      </span>
    )
  }

  renderNome = (data, registro) => {
    return (
      <span>
        {registro.nome_venda ? registro.nome_venda : registro.nome_os}
      </span>
    )
  }


  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Visualizar">
        <Button type="ghost" size="small" onClick={() => this.onVisualizarClick(registro)} icon="eye-o" />
      </Tooltip>
    );
  };

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, total, pagina, limite } = this.state;

    // console.log('PedidosProdutosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Relatório de Produtos Vendidos</span>
        <div className="divider-page" />

        <Row style={{ marginBottom: 10 }}>
          <div className="pageFiltro" style={{ height: 50 }}>
            <Row>
              <Col xs={11}>
                <Col xs={2} style={{ width: 110 }}>
                  <Button
                    type="primary"
                    onClick={this.onAbrirFiltroClick}
                    className="botao-primary"
                    style={{ marginRight: 15 }}
                  >
                    Filtrar
                  </Button>
                </Col>

                <Col xs={2} style={{ width: 110 }}>
                  <PedidosProdutosPrintModal
                    filtros={filtros}
                    totalVendas={this.state.totalVendas}
                    custoTotal={this.state.custoTotal}
                    custoMedioUnit={this.state.custoMedioUnit}
                    vendaMediaUnit={this.state.vendaMediaUnit}
                    lucroMedioUnit={this.state.lucroMedioUnit}
                    lucroTotal={this.state.lucroTotal}
                    qtdeVendas={this.state.qtdeVendas}
                  />
                </Col>

                <PedidoFiltroForm
                  visivel={formFiltroVisivel}
                  onFiltrarClick={this.onFiltrarClick}
                  onCancelarFiltroClick={this.onCancelarFiltroClick}
                  filtros={filtros}
                />
              </Col>
            </Row>

            <Row style={{ marginTop: 20 }}>
              <Col xs={24} md={24} style={{ height: 65, padding: 5, marginTop: -20 }}>
                <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                        Qtde Vendido
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeVendas}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                        Vlr Total Vendido
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalVendas)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                        Custo Médio Unit
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.custoMedioUnit)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                        Vlr Médio Venda
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vendaMediaUnit)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                        Lucro Médio Unit
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.lucroMedioUnit)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} md={4} style={{ height: 65, padding: 5 }}>
                  <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                    <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                      <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                        Lucro Total
                      </span>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Row style={{ marginTop: -5 }}>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.lucroTotal)}</span>
                      </Row>
                    </Row>
                  </div>
                </Col>
              </Col>
              {/* <Col xs={24} style={{ background: Colors.background, padding: 5, marginTop: -10 }}>
                <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white", marginLeft: 5 }} >
                  <Row><span style={{ fontWeight: "bold" }}>Qtde Vendido</span></Row>
                  <Row><span>{this.state.qtdeVendas}</span></Row>
                </Col>
                <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                  <Row><span style={{ fontWeight: "bold" }}>Vlr Total Vendido</span></Row>
                  <Row><span>R$ {this.renderValor(this.state.totalVendas)}</span></Row>
                </Col>
                <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                  <Row><span style={{ fontWeight: "bold" }}>Custo Médio Unit</span></Row>
                  <Row><span>R$ {this.renderValor(this.state.custoMedioUnit)}</span></Row>
                </Col>
                <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                  <Row><span style={{ fontWeight: "bold" }}>Vlr Médio Venda</span></Row>
                  <Row><span>R$ {this.renderValor(this.state.vendaMediaUnit)}</span></Row>
                </Col>
                <Col xs={24} sm={4} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                  <Row><span style={{ fontWeight: "bold" }}>Lucro Médio Unit</span></Row>
                  <Row><span>R$ {this.renderValor(this.state.lucroMedioUnit)}</span></Row>
                </Col>
                <Col xs={24} sm={3} style={{ marginRight: 0, textAlign: "center", background: "white" }} >
                  <Row><span style={{ fontWeight: "bold" }}>Lucro Total</span></Row>
                  <Row><span>R$ {this.renderValor(this.state.lucroTotal)}</span></Row>
                </Col>
              </Col> */}
            </Row>

            <VendaForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

          </div>
        </Row>

        <Row>
          <div style={{ paddingTop: 0 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.mi_idf)}
            >
              <Column
                key="ven_dt_venda"
                dataIndex="ven_dt_venda"
                title={this.renderTitulo("Emissão")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={110}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="ven_numero"
                dataIndex="ven_numero"
                title={this.renderTitulo("Número")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderNumero}
                width={80}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="pes_nome"
                dataIndex="pes_nome"
                title={this.renderTitulo("Cliente")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderNome}
                width={200}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="prod_codigo"
                dataIndex="prod_codigo"
                title={this.renderTitulo("Produto")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="prod_descricao"
                dataIndex="prod_descricao"
                title={this.renderTitulo("Descrição do Produto")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderDescrProduto}
                width={200}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="grp_descricao"
                dataIndex="grp_descricao"
                title={this.renderTitulo("Grupo")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={100}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="mi_qtde"
                dataIndex="mi_qtde"
                title={this.renderTitulo("Qtde")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_vlr_custo_unit"
                dataIndex="mi_vlr_custo_unit"
                title={this.renderTitulo("Vlr Custo")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_vlr_unit"
                dataIndex="mi_vlr_unit"
                title={this.renderTitulo("Vlr Unit")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_vlr_total"
                dataIndex="mi_vlr_total"
                title={this.renderTitulo("Vlr Total")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={90}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
                render={this.renderAcoes}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/PedidosProdutosPage.js